import { loadStripe, type Stripe } from '@stripe/stripe-js'

// loadStripe must be called once at module load (Stripe.js is a singleton).
// The publishable key (pk_…) is client-safe by design. When it's absent the
// card flow degrades to a clear "not configured" message rather than crashing.
const pk = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined

export const stripeConfigured = Boolean(pk)
export const stripePromise: Promise<Stripe | null> | null = pk ? loadStripe(pk) : null
